export function flatten(arg: any) {
    if (!Array.isArray(arg)) {
        return arg;
    }
    return arg.reduce((acc, x) => acc.concat(flatten(x)), []);
}
